import React, { useState, useRef, useEffect } from "react";
import { FaRegDotCircle, FaBars } from "react-icons/fa";
import { Drawer, Button, message } from "antd";
import Live from "./Live";
import Weekly from "./Weekly";
import FloorMap from "./FloorMap";
import axiosClient from "../../../Authentication/ApiCall";
import { CaretRightOutlined, CaretDownOutlined } from "@ant-design/icons";

const FootfallMall = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1150);
  const [floorMap, setFloorMap] = useState([]);
  const [floors, setFloors] = useState([]);
  const [zones, setZones] = useState([]);
  const [initialStores, setInitialStores] = useState(["Stores"]);
  const [stores, setStores] = useState([]);
  const [isFloorLiveOpen, setIsFloorLiveOpen] = useState(false);
  const [isFloorAnalyticOpen, setIsFloorAnalyticOpen] = useState(false);
  const [isFloorMapOpen, setIsFloorMapOpen] = useState(false);
  const [isZoneLiveOpen, setIsZoneLiveOpen] = useState(false);
  const [isZoneAnalyticOpen, setIsZoneAnalyticOpen] = useState(false);
  const [isZoneMapOpen, setIsZoneMapOpen] = useState(false);
  const [isStoresLiveOpen, setIsStoresLiveOpen] = useState(false);
  const [isStoresAnalyticOpen, setIsStoresAnalyticOpen] = useState(false);
  const [selectedFloorLive, setSelectedFloorLive] = useState(null);
  const [selectedFloorAnalytic, setSelectedFloorAnalytic] = useState(null);
  const [selectedZoneLive, setSelectedZoneLive] = useState(null);
  const [selectedZoneAnalytic, setSelectedZoneAnalytic] = useState(null);
  const [selectedZoneMap, setSelectedZoneMap] = useState(null);
  const [selectedStoresLive, setSelectedStoresLive] = useState(null);
  const [selectedStoresAnalytic, setSelectedStoresAnalytic] = useState(null);
  const [selectedFloorMap, setSelectedFloorMap] = useState(null);
  const [floorLiveProps, setFloorLiveProps] = useState(null);
  const [floorAnalyticsProps, setFloorAnalyticsProps] = useState(null);
  const [storesLiveProps, setStoresLiveProps] = useState(null);
  const [storesAnalyticsProps, setStoresAnalyticsProps] = useState(null);
  const [zoneLiveProps, setZoneLiveProps] = useState(null);
  const [zoneAnalyticsProps, setZoneAnalyticsProps] = useState(null);
  const [zoneMapProps, setZoneMapProps] = useState(null);
  const [floorMapProps, setFloorMapProps] = useState(null);
  const contentRef = useRef(null);


  const handleTabChange = (key) => {
    setActiveKey(key);
    //setIsDrawerOpen(false);

    if (key === "3" && floorMap.length > 0) {
      setSelectedFloorMap(0);
      setFloorMapProps(floorMap[0].id)
      getFloorZone(floorMap[0].id, key)
    }
    if (key !== "1") {
      setIsFloorLiveOpen(false)
      setIsZoneLiveOpen(false)
      setIsStoresLiveOpen(false)
    }
    if (key !== "2") {
      setIsFloorAnalyticOpen(false)
      setIsZoneAnalyticOpen(false)
      setIsStoresAnalyticOpen(false)
    }
    if (key !== "3") {
      setIsFloorMapOpen(false)
      setIsZoneMapOpen(false)
    }

    if (key === "1") {
      setSelectedFloorAnalytic(null);
      setSelectedFloorMap(null);
      setSelectedZoneAnalytic(null)
      setSelectedZoneMap(null)
      setSelectedStoresAnalytic(null)  
    }
    if (key === "2") {
      setSelectedFloorLive(null);
      setSelectedFloorMap(null);
      setSelectedZoneLive(null)
      setSelectedZoneMap(null)
      setSelectedStoresLive(null)      
    }
    if (key === "3") {
      setSelectedFloorLive(null);
      setSelectedFloorAnalytic(null);
      setSelectedZoneAnalytic(null)
      setSelectedZoneLive(null)
      setSelectedStoresLive(null)
      setSelectedStoresAnalytic(null)    
    }
  };

  const handleFloorClick = (index, key, floorId) => {
    setIsDrawerOpen(false)
    setZoneLiveProps(null)
    setZoneAnalyticsProps(null)
    setZoneMapProps(null)
    setStoresLiveProps(null)
    setStoresAnalyticsProps(null)
    if (key === "1") {
      setSelectedFloorLive(index);
      getFloorZone(floorId, key)
      setSelectedZoneLive(null)
      setSelectedStoresLive(null)
      setIsStoresLiveOpen(false)
    }
    else if (key === "2") {
      setSelectedFloorAnalytic(index);
      getFloorZone(floorId, key)
      setSelectedZoneAnalytic(null)
      setSelectedStoresAnalytic(null)
      setIsStoresAnalyticOpen(false)
    }
    else if (key === "3") {
      setSelectedFloorMap(index);
      getFloorZone(floorId, key)
      setSelectedZoneMap(null)
    }
  };

  const handleZoneClick = (index, key, floorId, zoneId) => {
    setIsDrawerOpen(false)
    if (key === "1") {
      setSelectedZoneLive(index)
    }
    if (key === "2") {
      setSelectedZoneAnalytic(index);
    }
    if (key === "3") {
      setSelectedZoneMap(index);
    }
  };

  const handleInitialStoresClick = (index, key) => {
    setIsDrawerOpen(false)
    if (key === "1") {
      setSelectedStoresLive(index)
      //setIsStoresLiveOpen(true)
      setIsStoresAnalyticOpen(false)
      setSelectedFloorLive(null)
      setIsZoneLiveOpen(false)
      setSelectedZoneLive(false)
      setFloorLiveProps(null)
      setZoneLiveProps(null)
      setStoresLiveProps(stores)
    }
    else if (key === "2") {
      setSelectedStoresAnalytic(index)
      setIsStoresLiveOpen(false)
      //setIsStoresAnalyticOpen(true)
      setSelectedFloorAnalytic(null)
      setIsZoneAnalyticOpen(false)
      setSelectedZoneAnalytic(false)
      setFloorAnalyticsProps(null)
      setZoneAnalyticsProps(null)
      setStoresAnalyticsProps(stores)
    }
  };

  const handleStoresClick = (index, key) => {
    setIsDrawerOpen(false)
    if (key === "1") {
      setSelectedStoresLive(index)
    }
    if (key === "2") {
      setSelectedStoresAnalytic(index);
    }
  };

  const toggleFloor = (key) => {
    if (key === "1") {
      setFloorLiveProps(null)
      setZoneLiveProps(null)
      setSelectedFloorLive(null);
      setIsFloorLiveOpen(!isFloorLiveOpen);
      setIsStoresLiveOpen(false)
      setSelectedZoneLive(null)
      setStoresLiveProps(null)
      setIsZoneLiveOpen(false)
      setSelectedStoresLive(null)
    }
    else if (key === "2") {
      setFloorAnalyticsProps(null)
      setZoneAnalyticsProps(null)
      setSelectedFloorAnalytic(null);
      setIsFloorAnalyticOpen(!isFloorAnalyticOpen);
      setIsStoresAnalyticOpen(false)
      setSelectedZoneAnalytic(null)
      setStoresAnalyticsProps(null)
      setIsZoneAnalyticOpen(false)
      setSelectedStoresAnalytic(null)
    }
    else if (key === "3") {            
      setIsFloorMapOpen(!isFloorMapOpen);
      if (!isFloorMapOpen && floorMap.length > 0) {
        setSelectedFloorMap(0);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (contentRef.current) {
      if (event.key === "PageDown") {
        contentRef.current.scrollBy({ top: window.innerHeight, behavior: "smooth" });
      }
      if (event.key === "PageUp") {
        contentRef.current.scrollBy({ top: -window.innerHeight, behavior: "smooth" });
      }
      if (event.key === "ArrowDown") {
        contentRef.current.scrollBy({ top: 100, behavior: "smooth" });
      }
      if (event.key === "ArrowUp") {
        contentRef.current.scrollBy({ top: -100, behavior: "smooth" });
      }
    }
  };

  const updateScreenSize = () => {
    setIsDesktop(window.innerWidth > 1150);
  };

  const getFloorZone = (floorId, key) => {   
    axiosClient
      .get("/zoneonboard/getfloorzoneeventdetails?id=" + floorId)
      .then((response) => {
        if (response.data.issuccess === true) {
          if (response.data.data) {
            setZones(response.data.data);
            if (response.data.data.length > 0) {             
              if (key === "1") {
                setIsZoneLiveOpen(true)
              }   
              if (key === "2") {
                setIsZoneAnalyticOpen(true)
              } 
              if (key === "3") {
                setIsZoneMapOpen(true)
              }                       
            }
            else {            
              if (key === "1") {
                setIsZoneLiveOpen(false)
              }   
              if (key === "2") {
                setIsZoneAnalyticOpen(false)
              }
              if (key === "3") {
                setIsZoneMapOpen(false)
              }
            }
          }
        }
      }).catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  }

  useEffect(() => {
    axiosClient
      .get("/flooronboard/getflooreventdetails")
      .then((response) => {
        if (response.data.issuccess === true) {
          if (response.data.data) {
            setFloors(response.data.data);
            setIsFloorLiveOpen(!isFloorLiveOpen);
            const floorData = response.data.data.filter((item) => item.floorImage !== 0)
            if (floorData.length > 0) {
              setFloorMap(floorData);
              setFloorMapProps(floorData[0].id)
            }
          }
        }
      }).catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });

      axiosClient
      .get("/storesConfig/getstoresdetails")
      .then((response) => {
        if (response.data.issuccess === true) {
          if (response.data.data) {
            setStores(response.data.data.sort((a,b) => a.storesName.localeCompare(b.storesName)));
          }
        }
      }).catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });

    window.addEventListener("resize", updateScreenSize);
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("resize", updateScreenSize);
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <div style={{ display: "flex", height: "100vh", width: "100vw" }}>
      {/* Mobile Drawer */}
      {!isDesktop && (
        <>
          <Button
            icon={<FaBars />}
            type="text"
            onClick={() => setIsDrawerOpen(true)}
            style={{
              fontSize: "24px",
              position: "absolute",
              top: "1rem",
              left: "1rem",
              zIndex: 1000,
              background: "transparent",
              border: "none",
            }}
          />
          <Drawer
            title="Dashboard"
            placement="left"
            onClose={() => setIsDrawerOpen(false)}
            open={isDrawerOpen}
            width="40%"
          >
            <ul style={{
              listStyle: "none",
              padding: 0,
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}>
              <li
                onClick={() => {
                  handleTabChange("1");
                  toggleFloor("1")
                }}
                style={{
                  cursor: "pointer",
                  padding: "1rem",
                  backgroundColor: activeKey === "1" ? "" : "#ffffff",
                  width: "100%",
                  textAlign: "start",
                  // fontWeight: "400",
                  color: activeKey === "1" ? "#1677ff" : "black",
                  fontSize: "18px",
                  fontWeight: "bold",
                  height: "3.6rem",
                }}
              >
                <p style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                  {isFloorLiveOpen ? (
                    <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                  ) : (
                    <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                  )}
                  Live <FaRegDotCircle color="green" />
                </p>
              </li>
              {activeKey === "1" && isFloorLiveOpen && (
                <ul
                  style={{
                    listStyle: "none",
                    paddingLeft: "0px",
                  }}
                >
                  {floors.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => { handleFloorClick(index, activeKey, item.id); setFloorLiveProps(item) }}
                      style={{
                        padding: "0.5rem",
                        fontSize: "15px",
                        //color: "black",
                        color: selectedFloorLive === index ? "#1677ff" : "black",
                        backgroundColor: selectedFloorLive === index ? zones.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                        fontWeight: selectedFloorLive === index ? "bold" : "normal",
                      }}
                    >
                      {isZoneLiveOpen && (zones[0].floorId === item.id) ? (
                        <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                      ) : (
                        <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                      )}
                      {item.floorName}
                      {zones.length > 0 &&
                      (isZoneLiveOpen && (zones[0].floorId === item.id) && (
                        <ul
                          style={{
                            listStyle: "none",
                            paddingLeft: "1rem",
                            marginTop: "0.5rem",
                          }}
                        >
                          {zones.map((zone, zoneIndex) => (
                            <li
                              key={zoneIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleZoneClick(zoneIndex, activeKey, item.id, zone.id);
                                setZoneLiveProps(zone);
                              }}
                              style={{
                                padding: "0.5rem",
                                fontSize: "15px",
                                color: "black",
                                backgroundColor: selectedZoneLive === zoneIndex ? "#B9D9EB" : "transparent",
                                fontWeight: selectedZoneLive === zoneIndex ? "bold" : "normal",
                              }}
                            >
                              {zone.zoneName}
                            </li>
                          ))}
                        </ul>
                      )
                      )}
                    </li>
                  ))}
                   {stores.length > 0 && (                  
                  initialStores.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => { handleInitialStoresClick(index, activeKey); }}
                      style={{
                        padding: "0.5rem",
                        fontSize: "15px",
                        //color: "black",
                        color: selectedStoresLive === index ? "#1677ff" : "black",
                        backgroundColor: selectedStoresLive === index ? stores.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                        fontWeight: selectedStoresLive === index ? "bold" : "normal",
                      }}
                    >
                      {isStoresLiveOpen ?  (
                        <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                      ) : (
                        <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                      )}
                      {item}
                      {/* {stores.length > 0 &&
                        (isStoresLiveOpen &&  (
                          <ul
                            style={{
                              listStyle: "none",
                              paddingLeft: "1rem",
                              marginTop: "0.5rem",
                            }}
                          >
                            {stores.map((store, storeIndex) => (
                              <li
                                key={storeIndex}
                                onClick={(e) => {
                                  e.stopPropagation();     
                                  handleStoresClick(storeIndex, activeKey, store.id);                           
                                  setStoresLiveProps(store);
                                }}
                                style={{
                                  padding: "0.5rem",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: selectedStoresLive === storeIndex ? "#B9D9EB" : "transparent",
                                  fontWeight: selectedStoresLive === storeIndex ? "bold" : "normal",
                                }}
                              >
                                {store.storesName}
                              </li>
                            ))}
                          </ul>
                        )
                        )} */}
                    </li>                  
                  ))
                )}
                </ul>
              )}
              <li onClick={() => {
                handleTabChange("2");
                toggleFloor("2");
              }}
                style={{
                  cursor: "pointer",
                  padding: "1rem",
                  backgroundColor: activeKey === "2" ? "" : "#ffffff",
                  width: "100%",
                  textAlign: "start",
                  // fontWeight: "400",
                  color: activeKey === "2" ? "#1677ff" : "black",
                  fontSize: "18px",
                  fontWeight: "bold",
                  height: "3.6rem",
                }}
              >
                {isFloorAnalyticOpen ? (
                  <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                ) : (
                  <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                )}
                Analytics
              </li>
              {activeKey === "2" && isFloorAnalyticOpen && (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: "0px",
                }}
              >
                {floors.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => { handleFloorClick(index, activeKey, item.id); setFloorAnalyticsProps(item) }}
                    style={{
                      padding: "0.5rem",
                      fontSize: "15px",
                      //color: "black",
                      color: selectedFloorAnalytic === index ? "#1677ff" : "black",
                      backgroundColor: selectedFloorAnalytic === index ? zones.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                      fontWeight: selectedFloorAnalytic === index ? "bold" : "normal",
                    }}
                  >
                    {isZoneAnalyticOpen && (zones[0].floorId === item.id) ? (
                      <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                    ) : (
                      <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                    )}
                    {item.floorName}
                    {zones.length > 0 &&
                      (isZoneAnalyticOpen && (zones[0].floorId === item.id) && (
                        <ul
                          style={{
                            listStyle: "none",
                            paddingLeft: "1rem",
                            marginTop: "0.5rem",
                          }}
                        >
                          {zones.map((zone, zoneIndex) => (
                            <li
                              key={zoneIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleZoneClick(zoneIndex, activeKey, item.id, zone.id);
                                setZoneAnalyticsProps(zone);
                              }}
                              style={{
                                padding: "0.5rem",
                                fontSize: "15px",
                                color: "black",
                                backgroundColor: selectedZoneAnalytic === zoneIndex ? "#B9D9EB" : "transparent",
                                fontWeight: selectedZoneAnalytic === zoneIndex ? "bold" : "normal",
                              }}
                            >
                              {zone.zoneName}
                            </li>
                          ))}
                        </ul>
                      )
                      )}
                  </li>
                ))}
                {stores.length > 0 && (                  
                  initialStores.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => { handleInitialStoresClick(index, activeKey); }}
                      style={{
                        padding: "0.5rem",
                        fontSize: "15px",
                        //color: "black",
                        color: selectedStoresAnalytic === index ? "#1677ff" : "black",
                        backgroundColor: selectedStoresAnalytic === index ? stores.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                        fontWeight: selectedStoresAnalytic === index ? "bold" : "normal",
                      }}
                    >
                      {isStoresAnalyticOpen ?  (
                        <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                      ) : (
                        <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                      )}
                      {item}
                      {/* {stores.length > 0 &&
                        (isStoresAnalyticOpen && (
                          <ul
                            style={{
                              listStyle: "none",
                              paddingLeft: "1rem",
                              marginTop: "0.5rem",
                            }}
                          >
                            {stores.map((store, storeIndex) => (
                              <li
                                key={storeIndex}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleStoresClick(storeIndex, activeKey, store.id);
                                  setStoresAnalyticsProps(store);
                                }}
                                style={{
                                  padding: "0.5rem",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: selectedStoresAnalytic === storeIndex ? "#B9D9EB" : "transparent",
                                  fontWeight: selectedStoresAnalytic === storeIndex ? "bold" : "normal",
                                }}
                              >
                                {store.storesName}
                              </li>
                            ))}
                          </ul>
                        )
                        )} */}
                    </li>                  
                  ))
                )}
              </ul>
            )}
              {floorMap.length > 0 ?
                <li onClick={() => {
                  handleTabChange("3");
                  toggleFloor("3");
                }}
                  style={{
                    cursor: "pointer",
                    padding: "1rem",
                    backgroundColor: activeKey === "3" ? "" : "#ffffff",
                    width: "100%",
                    textAlign: "start",
                    // fontWeight: "400",
                    color: activeKey === "3" ? "#1677ff" : "black",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  {isFloorMapOpen ? (
                    <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                  ) : (
                    <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                  )}
                  Floor Map
                </li> : <></>
              }
              {activeKey === "3" && isFloorMapOpen && (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: "0px",
                }}
              >
                {floorMap.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => { handleFloorClick(index, activeKey, item.id); setFloorMapProps(item.id) }}
                    style={{
                      padding: "0.5rem",
                      fontSize: "15px",
                      //color: "black",
                      color: selectedFloorMap === index ? "#1677ff" : "black",
                      backgroundColor: selectedFloorMap === index ? zones.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                      fontWeight: selectedFloorMap === index ? "bold" : "normal",
                    }}
                  >
                    {isZoneMapOpen && (zones[0].floorId === item.id) ? (
                      <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                    ) : (
                      <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                    )}
                    {item.floorName}
                    {zones.length > 0 &&
                      (isZoneMapOpen && (zones[0].floorId === item.id) && (
                        <ul
                          style={{
                            listStyle: "none",
                            paddingLeft: "1rem",
                            marginTop: "0.5rem",
                          }}
                        >
                          {zones.map((zone, zoneIndex) => (
                            <li
                              key={zoneIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleZoneClick(zoneIndex, activeKey, item.id, zone.id);
                                setZoneMapProps(zone);
                              }}
                              style={{
                                padding: "0.5rem",
                                fontSize: "15px",
                                color: "black",
                                backgroundColor: selectedZoneMap === zoneIndex ? "#B9D9EB" : "transparent",
                                fontWeight: selectedZoneMap === zoneIndex ? "bold" : "normal",
                              }}
                            >
                              {zone.zoneName}
                            </li>
                          ))}
                        </ul>
                      )
                      )}
                  </li>
                ))}
              </ul>
            )}  
            </ul>
          </Drawer>
        </>
      )}

      {/* Desktop Sidebar */}
      {isDesktop && (
        <div
          style={{
            width: "12%",
            backgroundColor: "#ffffff",
            borderRight: "1px solid rgba(0,0,0,0.25)",
            position: "sticky",
            height: "100vh",
          }}
        >
          {/* <h1 style={{ width: "100%", textAlign: "center" }}>Dashboard</h1> */}
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <li
              onClick={() => {
                handleTabChange("1");
                toggleFloor("1");
              }}
              style={{
                cursor: "pointer",
                padding: "1rem",
                backgroundColor: activeKey === "1" ? "" : "#ffffff",
                width: "100%",
                textAlign: "start",
                // fontWeight: "400",
                color: activeKey === "1" ? "#1677ff" : "black",
                fontSize: "18px",
                fontWeight: "bold",
                height: "3.6rem",
              }}
            >
              <p style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                {isFloorLiveOpen ? (
                  <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                ) : (
                  <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                )}
                Live <FaRegDotCircle color="green" />
              </p>
            </li>
            {activeKey === "1" && isFloorLiveOpen && (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: "0px",
                }}
              >
                {floors.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => { handleFloorClick(index, activeKey, item.id); setFloorLiveProps(item) }}
                    style={{
                      padding: "0.5rem",
                      fontSize: "15px",
                      //color: "black",
                      color: selectedFloorLive === index ? "#1677ff" : "black",
                      backgroundColor: selectedFloorLive === index ? zones.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                      fontWeight: selectedFloorLive === index ? "bold" : "normal",
                    }}
                  >
                    {isZoneLiveOpen && (zones[0].floorId === item.id) ? (
                      <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                    ) : (
                      <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                    )}
                    {item.floorName}
                    {zones.length > 0 &&
                      (isZoneLiveOpen && (zones[0].floorId === item.id) && (
                        <ul
                          style={{
                            listStyle: "none",
                            paddingLeft: "1rem",
                            marginTop: "0.5rem",
                          }}
                        >
                          {zones.map((zone, zoneIndex) => (
                            <li
                              key={zoneIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleZoneClick(zoneIndex, activeKey, item.id, zone.id);
                                setZoneLiveProps(zone);
                              }}
                              style={{
                                padding: "0.5rem",
                                fontSize: "15px",
                                color: "black",
                                backgroundColor: selectedZoneLive === zoneIndex ? "#B9D9EB" : "transparent",
                                fontWeight: selectedZoneLive === zoneIndex ? "bold" : "normal",
                              }}
                            >
                              {zone.zoneName}
                            </li>
                          ))}
                        </ul>
                      )
                      )}
                  </li>                  
                ))}
                {stores.length > 0 && (                  
                  initialStores.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => { handleInitialStoresClick(index, activeKey); }}
                      style={{
                        padding: "0.5rem",
                        fontSize: "15px",
                        //color: "black",
                        color: selectedStoresLive === index ? "#1677ff" : "black",
                        backgroundColor: selectedStoresLive === index ? stores.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                        fontWeight: selectedStoresLive === index ? "bold" : "normal",
                      }}
                    >
                      {isStoresLiveOpen ?  (
                        <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                      ) : (
                        <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                      )}
                      {item}
                      {/* {stores.length > 0 &&
                        (isStoresLiveOpen &&  (
                          <ul
                            style={{
                              listStyle: "none",
                              paddingLeft: "1rem",
                              marginTop: "0.5rem",
                            }}
                          >
                            {stores.map((store, storeIndex) => (
                              <li
                                key={storeIndex}
                                onClick={(e) => {
                                  e.stopPropagation();     
                                  handleStoresClick(storeIndex, activeKey, store.id);                           
                                  setStoresLiveProps(store);
                                }}
                                style={{
                                  padding: "0.5rem",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: selectedStoresLive === storeIndex ? "#B9D9EB" : "transparent",
                                  fontWeight: selectedStoresLive === storeIndex ? "bold" : "normal",
                                }}
                              >
                                {store.storesName}
                              </li>
                            ))}
                          </ul>
                        )
                        )} */}
                    </li>                  
                  ))
                )}
              </ul>
            )}
            <li
              onClick={() => {
                handleTabChange("2");
                toggleFloor("2");
              }}
              style={{
                cursor: "pointer",
                padding: "1rem",
                backgroundColor: activeKey === "2" ? "" : "#ffffff",
                width: "100%",
                textAlign: "start",
                // fontWeight: "400",
                color: activeKey === "2" ? "#1677ff" : "black",
                fontSize: "18px",
                fontWeight: "bold",
                height: "3.6rem",
              }}
            >
              {isFloorAnalyticOpen ? (
                <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
              ) : (
                <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
              )}
              <span>Analytics</span>
            </li>
            {activeKey === "2" && isFloorAnalyticOpen && (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: "0px",
                }}
              >
                {floors.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => { handleFloorClick(index, activeKey, item.id); setFloorAnalyticsProps(item) }}
                    style={{
                      padding: "0.5rem",
                      fontSize: "15px",
                      //color: "black",
                      color: selectedFloorAnalytic === index ? "#1677ff" : "black",
                      backgroundColor: selectedFloorAnalytic === index ? zones.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                      fontWeight: selectedFloorAnalytic === index ? "bold" : "normal",
                    }}
                  >
                    {isZoneAnalyticOpen && (zones[0].floorId === item.id) ? (
                      <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                    ) : (
                      <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                    )}
                    {item.floorName}
                    {zones.length > 0 &&
                      (isZoneAnalyticOpen && (zones[0].floorId === item.id) && (
                        <ul
                          style={{
                            listStyle: "none",
                            paddingLeft: "1rem",
                            marginTop: "0.5rem",
                          }}
                        >
                          {zones.map((zone, zoneIndex) => (
                            <li
                              key={zoneIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleZoneClick(zoneIndex, activeKey, item.id, zone.id);
                                setZoneAnalyticsProps(zone);
                              }}
                              style={{
                                padding: "0.5rem",
                                fontSize: "15px",
                                color: "black",
                                backgroundColor: selectedZoneAnalytic === zoneIndex ? "#B9D9EB" : "transparent",
                                fontWeight: selectedZoneAnalytic === zoneIndex ? "bold" : "normal",
                              }}
                            >
                              {zone.zoneName}
                            </li>
                          ))}
                        </ul>
                      )
                      )}
                  </li>
                ))}
                 {stores.length > 0 && (                  
                  initialStores.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => { handleInitialStoresClick(index, activeKey); }}
                      style={{
                        padding: "0.5rem",
                        fontSize: "15px",
                        //color: "black",
                        color: selectedStoresAnalytic === index ? "#1677ff" : "black",
                        backgroundColor: selectedStoresAnalytic === index ? stores.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                        fontWeight: selectedStoresAnalytic === index ? "bold" : "normal",
                      }}
                    >
                      {isStoresAnalyticOpen ?  (
                        <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                      ) : (
                        <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                      )}
                      {item}
                      {/* {stores.length > 0 &&
                        (isStoresAnalyticOpen &&  (
                          <ul
                            style={{
                              listStyle: "none",
                              paddingLeft: "1rem",
                              marginTop: "0.5rem",
                            }}
                          >
                            {stores.map((store, storeIndex) => (
                              <li
                                key={storeIndex}
                                onClick={(e) => {
                                  e.stopPropagation();     
                                  handleStoresClick(storeIndex, activeKey, store.id);                           
                                  setStoresAnalyticsProps(store);
                                }}
                                style={{
                                  padding: "0.5rem",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: selectedStoresAnalytic === storeIndex ? "#B9D9EB" : "transparent",
                                  fontWeight: selectedStoresAnalytic === storeIndex ? "bold" : "normal",
                                }}
                              >
                                {store.storesName}
                              </li>
                            ))}
                          </ul>
                        )
                        )} */}
                    </li>                  
                  ))
                )}
              </ul>
            )}
            {floorMap.length > 0 ?
              <li
                onClick={() => {
                  handleTabChange("3");
                  toggleFloor("3");
                }}
                style={{
                  cursor: "pointer",
                  padding: "1rem",
                  backgroundColor: activeKey === "3" ? "" : "#ffffff",
                  width: "100%",
                  textAlign: "start",
                  // fontWeight: "400",
                  color: activeKey === "3" ? "#1677ff" : "black",
                  fontSize: "18px",
                  fontWeight: "bold",
                  height: "3.6rem",
                }}
              >
                {isFloorMapOpen ? (
                  <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                ) : (
                  <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                )}
                <span>Floor Map</span>
              </li> : <></>
            }            
            {activeKey === "3" && isFloorMapOpen && (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: "0px",
                }}
              >
                {floorMap.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => { handleFloorClick(index, activeKey, item.id); setFloorMapProps(item.id) }}
                    style={{
                      padding: "0.5rem",
                      fontSize: "15px",
                      //color: "black",
                      color: selectedFloorMap === index ? "#1677ff" : "black",
                      backgroundColor: selectedFloorMap === index ? zones.length === 0 ? "#B9D9EB" : "transparent" : "transparent",
                      fontWeight: selectedFloorMap === index ? "bold" : "normal",
                    }}
                  >
                    {isZoneMapOpen && (zones[0].floorId === item.id) ? (
                      <CaretDownOutlined style={{ fontSize: "18px", color: "black" }} />
                    ) : (
                      <CaretRightOutlined style={{ fontSize: "18px", color: "black" }} />
                    )}
                    {item.floorName}
                    {zones.length > 0 &&
                      (isZoneMapOpen && (zones[0].floorId === item.id) && (
                        <ul
                          style={{
                            listStyle: "none",
                            paddingLeft: "1rem",
                            marginTop: "0.5rem",
                          }}
                        >
                          {zones.map((zone, zoneIndex) => (
                            <li
                              key={zoneIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleZoneClick(zoneIndex, activeKey, item.id, zone.id);
                                setZoneMapProps(zone);
                              }}
                              style={{
                                padding: "0.5rem",
                                fontSize: "15px",
                                color: "black",
                                backgroundColor: selectedZoneMap === zoneIndex ? "#B9D9EB" : "transparent",
                                fontWeight: selectedZoneMap === zoneIndex ? "bold" : "normal",
                              }}
                            >
                              {zone.zoneName}
                            </li>
                          ))}
                        </ul>
                      )
                      )}
                  </li>
                ))}
              </ul>
            )}                       
          </ul>
        </div>
      )}

      {/* Content Container */}
      <div ref={contentRef} style={{ width: isDesktop ? "88%" : "100%", height: "100vh", overflowY: "scroll" }}>
        {activeKey === "1" && <Live props={[floorLiveProps, zoneLiveProps, storesLiveProps]} />}
        {activeKey === "2" && <Weekly props={[floorAnalyticsProps, zoneAnalyticsProps, storesAnalyticsProps]} />}
        {activeKey === "3" && <FloorMap props={[floorMapProps, zoneMapProps]} />}
      </div>
    </div>
  );
};

export default FootfallMall;
